<template>
    <div class="main">
        <a-card :bordered="false" class="search" style="padding:0 20px;">
            搜索：
            <a-input-search
                    placeholder="请输入您要搜索的关键词"
                    style="width: 400px;margin-right: 20px"
                    v-model="keyword"
                    @search="onSearch"
            />
            <a-button type="primary" @click="reset()">重置</a-button>
            <div style="float: right;margin-right: 40px">
                <a-tag color="#f50">今日更新</a-tag>{{ dayCount }}条
                <a-tag color="#87d068" style="margin-left: 20px">文章总数</a-tag>{{ allCount }}篇
            </div>
        </a-card>
        <div

                v-infinite-scroll="loadmore"
                :infinite-scroll-disabled="busy"
                :infinite-scroll-distance="10"
        >
            <a-spin tip="Loading..." :spinning="spinning">
                <a-card :bordered="false" style="min-height: 700px;padding:0 20px;">
                    <a-list itemLayout="vertical">
                        <a-list-item :key="index" v-for="(item,index) in lists">
                            <a-list-item-meta :title="item.Title">
                                <!--<div slot="description">-->
                                <!--<a-tag >Ant Design</a-tag>-->
                                <!--<a-tag >设计语言</a-tag>-->
                                <!--<a-tag >蚂蚁金服</a-tag>-->
                                <!--</div>-->
                            </a-list-item-meta>
                            <div class="content">
                                <div class="detail">{{ item.Content }}<a :href="item.Url" target="_blank">...... 点击查看原文</a></div>
                                <div class="author">
                                    <a> {{ item.BizName }} </a>发布于
                                    <a :href="item.Url" target="_blank">http://mp.weixin.qq.com</a>
                                    <em>发布时间：{{item.PubTime}}</em>


                                </div>
                            </div>
                            <span slot="actions"><a-icon style="margin-right: 8px" type="star-o" />{{ item.ReadNumber }}</span>
                            <span slot="actions"><a-icon style="margin-right: 8px" type="like-o" />{{ item.LikeNumber }}</span>
                            <span slot="actions">数据最后更新时间：{{ item.UpdateTime }}</span>
                            <!--<span slot="actions"><a-icon style="margin-right: 8px" type="message" />4</span>-->
                        </a-list-item>
                    </a-list>
                </a-card>
            </a-spin>
        </div>
    </div>

</template>

<script>
    import infiniteScroll from 'vue-infinite-scroll'
    import moment from 'moment';

    export default {
        name: "Lists",
        directives: { infiniteScroll },
        data(){
          return {
              busy: false,
              allloaded: false,
              param: {page: 1},
              spinning: false,
              lists: [],
              dayCount: 0,
              allCount: 0,
              keyword: '',
              aid:0
          }
        },
        created(){
            this.spinning = true
            let siteInfo = JSON.parse(window.localStorage.getItem('siteinfo'))
            this.areaid = siteInfo.area_id
            this.$http.get('http://yq.ycydt.cn/index.php/api/area')
                .then(res=>{
                    if (res.data.state == 200) {
                        for (let i in res.data.data){
                            if (res.data.data[i].ucid == this.areaid){
                                this.aid = res.data.data[i].id
                                this.spinning = false
                                this.getLists()
                            }
                        }
                        // if (this.param.aid == 0) this.param.aid = res.data.data[0].id
                        // this.areaChange(this.param.aid)
                        // this.areaLists = res.data.data
                    }
                })

            this.getDayCount()
        },
        methods: {
            moment,
            reset(){
                this.allloaded = false
                this.param.page = 1
                this.lists = []
                this.keyword = ''
                this.getLists()
            },
            getDayCount(){
              this.$http.get('http://yq.ycydt.cn/index.php/api/wxDayContNum')
                  .then( res => {
                      this.dayCount = res.data.data.daynumb
                      this.allCount = res.data.data.countnumb
                      console.log(res.data)
                  })
            },
            onSearch(){
                this.allloaded = false
                this.param.page = 1
                this.lists = []
                this.getLists()
              // console.log('search')
            },
            loadmore(){
                console.log('loadmore')
                this.getLists();
            },
            getLists() {
                this.busy = true
                if (!this.spinning && !this.allloaded){
                    this.spinning = true
                    this.$http.post('http://yq.ycydt.cn/index.php/api/wxNewsList', {page:this.param.page, keyword:this.keyword, aid:this.aid})
                        .then(res => {
                            if (res.data.state == 200) {

                                for (let i in res.data.data) {
                                    let data =res.data.data[i]
                                    data.PubTime = moment(res.data.data[i].PubTime).format('YYYY-MM-DD hh:mm:ss')
                                    data.UpdateTime = moment(res.data.data[i].UpdateTime).format('YYYY-MM-DD hh:mm:ss')
                                    data.LogoUrl = data.LogoUrl.replace('-BizLogoCut','')
                                    data.Content = data.Content.replace(/<\/?.+?>/g,"").substr(0,200)
                                    this.lists.push(data)
                                }
                                if (this.lists.length < res.data.total) {
                                    this.param.page ++
                                } else{
                                    this.loading = true
                                    this.allloaded = true
                                    this.$message.warn('所有数据都已加载完毕')
                                }
                                this.spinning = false
                                this.busy = false

                            }
                        })
                }

            }
        }

    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 10px;
        overflow-y: auto;
        /*margin: 50px 0 0 10px;*/
    }
    .search {
        height: 60px;
        line-height: 60px;
    }
</style>

<style lang="less" scoped>
    .extra{
        width: 272px;
        height: 1px;
    }
    .content {
        .detail {
            line-height: 22px;
            /*max-width: 720px;*/
        }
        .author {
            color: rgba(0,0,0,.45);
            margin-top: 16px;
            line-height: 22px;
            & > :global(.ant-avatar) {
                vertical-align: top;
                margin-right: 8px;
                width: 20px;
                height: 20px;
                position: relative;
                top: 1px;
            }
            & > em {
                color: rgba(0,0,0,.25);
                font-style: normal;
                margin-left: 16px;
            }
        }
    }
</style>
